import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService           from 'FactoryService.js';
import constants                from 'Constants.js';
import sequenceService          from 'SequenceService.js';
import ControlModel    from 'ControlModel.js';
import DataControlView      from 'report/DataControlView.js';
import listService from 'ListService';


class ControlDataListFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        attributes.dataSourceId = 'null';
        //adding silent(accessibility) to attributes.
		attributes.silent = false;

		attributes.styleColorText ='#000000';

        // Rows
        attributes.fontFamily =  listService.accountSettings.DefaultFontSelected || "verdana";
        attributes.fontSize = '10';
        attributes.textWeight = '';
        attributes.textStyle  = '';

        attributes.headerTextColor ='#000000';
        attributes.headerFontFamily = listService.accountSettings.DefaultFontSelected || "verdana";
        attributes.headerFontSize = '10';
        attributes.headerTextWeight = '';
        attributes.headerTextStyle  = '';

        attributes.backgroundColor = '~buttonBgColor';
        attributes.advancedBgGradientColor = '~buttonBgGradientColor';

        attributes.headerBgColor = '~tableHeaderBgColor';
        attributes.normalRowBgColor = '~tableRowColor1';
        attributes.alternateRowBgColor = '~tableRowColor2';
        attributes.headerBoldSelection = 'transparent';
        attributes.headerItalicSelection = 'transparent';
        
        attributes.height = 200;
        attributes.rowHeight = 25;
        attributes.maxRows = 10;
        attributes.variableRowHeight = '';
        attributes.headerHeight = 20;
        attributes.bodyHeight = 140;
        attributes.showNavButtons = true;
        attributes.showNavButtonsHide = '';
        attributes.showDsInfo = true;
        attributes.showDsInfoHide = '';
        attributes.allowExport = false;
        attributes.allowExportHide = 'hidden';

        attributes.additiveDynamicFilter = 'false';
        attributes.setDynamicFilter = 'true';
        attributes.respectDynamicFilter = 'true';
        attributes.ignoreNull = 'false';

        attributes.numberDecimals = 2;
        attributes.numberSymbol = '';
        attributes.numberDecimalSeparator = '.';
        attributes.numberThousandSeparator = ',';
        attributes.dateFormat = 'MM.DD.YYYY';
        attributes.time24Hour = '';
        attributes.timeShowSeconds = '';
        attributes.booleanYes = '';
        attributes.booleanNo = '';
        attributes.percentageDecimals = 2;      

        attributes.setFilter = 'checked';
        attributes.overridePrevious = '';
        attributes.showAllValues = '';
        attributes.linksNewWindow = 'true'; 
        attributes.description = '';

        attributes.hasAggregate = false;
        attributes.columncolumnAggregate = 'Group';
        attributes.columnField = 'none';
        attributes.columnSort =  'none';
        attributes.columnWidth = 150;
        attributes.columnHidden = '';
        attributes.columnAlign = 'left';
        attributes.columnIncludeFilter = '';
        attributes.columnFormat = 'None';

        attributes.gridData = [];
        attributes.resizePadding = 2;
		attributes.minWidth = 280;
		attributes.minHeight = 150;
        attributes.lowestHeight = 150;

        const view = new DataControlView( { 
            model: new ControlModel( attributes ),
            el: $(constants.FORM_ID),
            pos: pos, 
            factoryKey: factoryKey, 
            id: attributes.id
        });

        return view;
    }

}

const controlDataListFactory = new ControlDataListFactory();

export default controlDataListFactory;